import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SetFocusDirective } from './set-focus.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [SetFocusDirective],
  exports: [SetFocusDirective]
})
export class SetFocusModule {}
